import React from 'react'
import { Input } from 'antd'
import { Sale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  saleFilterTextSelector,
  setMySalesFilterText,
  oldSaleListSelector,
  setMySalesFiltered,
} from 'src/features'

const SaleFilterInput = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const filterText = useAppSelector(saleFilterTextSelector)
  const oldSaleList = useAppSelector(oldSaleListSelector)

  const handleChange = (event: any) => {
    const value = event.target.value
    dispatch(setMySalesFilterText(value))
    const newSaleList: Sale[] = getSalesFiltered(value)
    dispatch(setMySalesFiltered(newSaleList))
  }

  const getSalesFiltered = (searchText: string) => {
    const text = searchText?.toLowerCase()
    if ([text === undefined, text === null, text?.trim()?.length === 0].includes(true)) return oldSaleList
    return oldSaleList.filter((sale: Sale)=> sale.projectName.toLowerCase().includes(searchText))
  }

  return (
    <Input
      onChange={handleChange}
      value={filterText}
      placeholder={t('Offers.OffersPlaceHolder')}
      prefix={<SearchOutlined className='site-form-item-icon' />}
      allowClear
    />
  )
}

export default SaleFilterInput
